import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
import LKModal from '../../components/Modal/Modal';
import { submitPowers, updatePackages } from '../../../actionCreators/success';
import './ConfirmationModal.scss';
// utils
import { sameFields } from './power-utils';

class ConfirmationModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            powerSubmitError: false
        };
        this.mutators = {
            onChange: (args, state, utils) => {
                utils.changeValue(state, args[0], () => args[1]);
            }
        };
        this.setSameFieldValues = this.setSameFieldValues.bind(this);
        this.submitPower = this.submitPower.bind(this);
    }

    componentDidMount() {
        this.prescriptionValues = [];
    }

    componentDidUpdate(prevProps) {
        const { powerSubmitted, powerSubmitFail, hideHandler, packageSubmitted, packageSubmittedFail, dataLocale: { SYSTEM_ERROR_PLEASE_TRY_AGAIN } } = this.props;
        if (prevProps.powerSubmitted !== powerSubmitted && powerSubmitted) {
            hideHandler();
        }
        if (prevProps.powerSubmitFail !== powerSubmitFail && powerSubmitFail) {
            (() => { this.setState({ powerSubmitError: powerSubmitFail.message || SYSTEM_ERROR_PLEASE_TRY_AGAIN }); })();
        }
        if (prevProps.packageSubmitted !== packageSubmitted && (packageSubmitted || packageSubmittedFail)) {
            hideHandler();
        }
    }

    getUserName() {
        const { order } = this.props;
        const { billingAddress } = order;
        const { firstName = '', lastName = '' } = billingAddress || {};
        return `${firstName} ${lastName}`;
    }

    setSameFieldValues(valueObj, checked) {
        if (sameFields.indexOf(valueObj.type) === -1) return;
        const { item } = this.props;
        const [key, type] = valueObj.name.split('-');
        const ctype = type === 'left' ? 'right' : 'left';
        this.form_mutators.onChange(key + '-' + ctype, checked);

        if (item.lensType !== 'BIFOCAL') return;
        if (key === 'bottomDistance' && !checked) {
            this.form_mutators.onChange('lensHeight-left', checked);
            this.form_mutators.onChange('lensHeight-right', checked);
            this.form_mutators.onChange('lensWidth-left', checked);
            this.form_mutators.onChange('lensWidth-right', checked);
        } else if ((key === 'lensHeight' || key === 'lensWidth') && checked) {
            this.form_mutators.onChange('bottomDistance-left', checked);
            this.form_mutators.onChange('bottomDistance-right', checked);
        }
    }

    addOrRemovePrescription(valueObj, add) {
        const { values } = this.props;
        if (add) {
            values.forEach(presc => {
                if (presc.type === valueObj.type) {
                    this.prescriptionValues.push(presc);
                }
            });
        } else {
            this.prescriptionValues = this.prescriptionValues.filter(p => p.type !== valueObj.type);
        }
    }

    submitPower(formValues) {
        const updatedBy = sessionStorageHelper.getItem('updatedBy');
        const { item = {}, submitPower, order = {}, values = [], changedPackage = {}, updatePackage, source } = this.props;
        const { prescription: presc, id } = item;
        const prescription = { ...presc, updatedBy, source };
        const { customerEmail } = order;
        const prescriptionValues = values.filter(v => formValues[v.name]);
        if (prescriptionValues && prescriptionValues.length && prescription) {
            prescriptionValues.reduce((memo, presObj) => {
                if (presObj.eyeLR === 'left') {
                    if (!memo.left) memo.left = {};
                    memo.left[presObj.type] = presObj.value;
                }
                if (presObj.eyeLR === 'right') {
                    if (!memo.right) memo.right = {};
                    memo.right[presObj.type] = presObj.value;
                }
                return memo;
            }, prescription);
            if (!prescription.userName) prescription.userName = this.getUserName();
            submitPower(id, prescription, customerEmail, order.id);
        }
        if (formValues.package) {
            const powerType = prescription.powerType && prescription.powerType.toLowerCase();
            const lensPackage = {
                productId: item.productId + '',
                powerType,
                packageId: changedPackage.value,
                updatedBy,
                source
            };
            updatePackage(item.id, lensPackage, order.id);
        }
    }

    render() {
        const { values, showModal, hideHandler, submitPowerLoader, changedPackage, dataLocale } = this.props;
        const { powerSubmitError } = this.state;
        const { ALL_MODIFIED_POWER_OPTIONS, MODIFIED_VALUE, POWER_OPTION, PACKAGE, CHECK_TO_CONFIRM, SUBMIT, CANCEL, OOPS_YOU_HAVE_NOT_CHANGED_ANYTHING, OK } = dataLocale;
        return (
            <LKModal size="lg" backdrop showModal={showModal} onHide={hideHandler}>
                {values && values.length > 0 || changedPackage ? (
                    <Form
                        onSubmit={this.submitPower}
                        mutators={this.mutators}
                    >
                        {({ handleSubmit, form, values: formValues }) => {
                            this.form_mutators = form.mutators;
                            const enableSubmit = formValues && Object.keys(formValues).some(key => formValues[key]);
                            return (
                                <form className="update-power-modal" onSubmit={handleSubmit}>
                                    <div className="update-power-header">{ALL_MODIFIED_POWER_OPTIONS}</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
                                        <div className="fs15 padding-b3 fw700">{POWER_OPTION}</div>
                                        <div className="fs15 fw700">{MODIFIED_VALUE}</div>
                                        <div className="fs15 text-center fw700">{CHECK_TO_CONFIRM}</div>
                                        {values.map(valueObj => {
                                            return (<React.Fragment key={valueObj.name}>
                                                <div className="text-capitalize fs13">{valueObj.label}</div>
                                                <div className="fs13 padding-t3 padding-b3">{valueObj.value}</div>
                                                <div className="text-center"><Field name={valueObj.name} component="input" type="checkbox" className="cursor-pointer" onClick={ev => { this.setSameFieldValues(valueObj, ev.target.checked); }} ></Field></div>
                                            </React.Fragment>);
                                        })}
                                        {changedPackage && <React.Fragment>
                                            <div className="text-capitalize fs13">{PACKAGE}</div>
                                            <div className="fs13 padding-t3 padding-b3">{changedPackage.name}</div>
                                            <div className="text-center"><Field name="package" component="input" type="checkbox" className="cursor-pointer"></Field></div>
                                        </React.Fragment>}
                                    </div>
                                    {powerSubmitError && <div className="error margin-t20 text-center">{powerSubmitError}</div>}
                                    <div className="modal-btns margin-t25">
                                        <button type="submit" className={`submit bora-2 fw700 ${enableSubmit ? '' : 'disabled'}`}>
                                            {submitPowerLoader ?
                                                <span className="fa fa-spinner fa-pulse fa-1x fa-fw"></span> :
                                                <span className="text-capitalize">{SUBMIT}</span>
                                            }
                                        </button>
                                        <button type="button" onClick={hideHandler} className="cancel bora-2 fw700 text-capitalize">{CANCEL}</button>
                                    </div>
                                </form>
                            );
                        }}
                    </Form>
                ) : (<div className="update-power-modal">
                    <div className="fs16 margin-b15 text-center">{OOPS_YOU_HAVE_NOT_CHANGED_ANYTHING}</div>
                    <div className="modal-btns">
                        <button type="button" className="submit" onClick={hideHandler}>{OK}</button>
                    </div>
                </div>)}
            </LKModal>
        );
    }
}

function mapStateToProps(state) {
    const order = state.order.orderDetails ? state.order.orderDetails.result : undefined;
    return {
        submitPowerLoader: state.success.loading,
        powerSubmitted: state.success.powerSubmitted,
        powerSubmitFail: state.success.powerSubmitFail,
        packageSubmitted: state.success.packageSubmitted,
        packageSubmittedFail: state.success.packageSubmittedFail,
        dataLocale: state.locale,
        order
    };
}


function mapDispatchToProps(dispatch) {
    return {
        submitPower: (id, prescription, email, orderId) => dispatch(submitPowers(id, prescription, email, orderId)),
        updatePackage: (id, lensPackage, orderId) => dispatch(updatePackages(id, lensPackage, orderId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
